<template>
  <div class="window" v-show="displayChange">
    <!-- hidden隐藏可能影响播放 -->
    <audio
      id="audio"
      src="https://downsc.chinaz.net/Files/DownLoad/sound1/201601/6809.mp3"
      controls
      hidden="true"
      loop
    ></audio>
    <!-- 样式方式隐藏， -->
    <!-- <audio
      id="audio"
      src="https://downsc.chinaz.net/Files/DownLoad/sound1/201601/6809.mp3"
      controls
      style="height:0;float:left"
    ></audio> -->
    <div class="window-title">
      <span class="title-name">告警提醒中心</span>
      <div class="btn-box">
        <span
          v-if="hasPerm('warn:remind:set:query')"
          class="iconfont icon-set"
          @click="getSetAlarm"
        ></span>
        <span class="iconfont icon-close" @click="showChange"></span>
      </div>
    </div>
    <div class="window-con">
      <div class="alarm-record">
        <span>发电告警（条）：</span>
        <span
          :class="alarmCount.dynamoStatus == 1 ? 'change' : 'red'"
          @click="toAlarmMonitor(1000)"
          >{{ alarmCount.dynamoCount }}</span
        >
      </div>
      <div class="alarm-record">
        <span>车辆告警（条）：</span>
        <span
          :class="alarmCount.vehicleStatus == 1 ? 'change' : 'red'"
          @click="toAlarmMonitor(1100)"
          >{{ alarmCount.vehicleCount }}</span
        >
      </div>
      <div class="alarm-record">
        <span>违规操作告警（条）：</span>
        <span
          :class="alarmCount.violationStatus == 1 ? 'change' : 'red'"
          @click="toAlarmMonitor(1200)"
          >{{ alarmCount.violationCount }}</span
        >
      </div>
      <div class="alarm-record">
        <span>维保告警（条）：</span>
        <span
          :class="alarmCount.maintenanceStatus == 1 ? 'change' : 'red'"
          @click="toAlarmMonitor(1300)"
          >{{ alarmCount.maintenanceCount }}</span
        >
      </div>
      <div class="alarm-record">
        <span>工单告警（条）：</span>
        <span
          :class="alarmCount.orderStatus == 1 ? 'change' : 'red'"
          @click="toAlarmMonitor(1400)"
          >{{ alarmCount.orderCount }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alarmCount: {},
      displayChange: false,
      alarmRules: {},
      refreshTime: null,
      closeTime: null,
      myaudio: null,
    }
  },
  created() {
    // let _this = this

    this.getAlarmSet()
    // setTimeout(() => {
    //   console.log("23")
    //   _this.getAlarmCount()
    // }, 100)
  },
  mounted() {
    this.myaudio = document.getElementById("audio")
  },
  methods: {
    // 告警数量
    async getAlarmCount() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/warn/remind/count")
      if (res.code == 1) {
        _this.alarmCount = res.data
        _this.myaudio.pause()
        if (_this.alarmCount.dynamoStatus == 1) {
          if (_this.alarmRules.dynamoVoice == 1) {
            _this.myaudio.play()
            return
          }
        }
        if (_this.alarmCount.vehicleStatus == 1) {
          if (_this.alarmRules.vehicleVoice == 1) {
            _this.myaudio.play()
            return
          }
        }
        if (_this.alarmCount.violationStatus == 1) {
          if (_this.alarmRules.violationVoice == 1) {
            _this.myaudio.play()
            return
          }
        }
        if (_this.alarmCount.maintenanceStatus == 1) {
          if (_this.alarmRules.maintenanceVoice == 1) {
            _this.myaudio.play()
            return
          }
        }
        if (_this.alarmCount.orderStatus == 1) {
          if (_this.alarmRules.orderVoice == 1) {
            _this.myaudio.play()
            return
          }
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //跳转告警监控
    toAlarmMonitor(type) {
      this.myaudio.pause()
      if (type == 1000) {
        this.alarmCount.dynamoStatus = 0
      } else if (type == 1100) {
        this.alarmCount.vehicleStatus = 0
      } else if (type == 1200) {
        this.alarmCount.violationStatus = 0
      } else if (type == 1300) {
        this.alarmCount.maintenanceStatus = 0
      } else if (type == 1400) {
        this.alarmCount.orderStatus = 0
      }
      this.$router.push({
        name: "AlarmMonitor",
        query: {
          parentType: type,
          t: Date.now(),
        },
      })
      this.$store.state.MenuStore.menu_path = "运维监控 > 告警监控"
    },
    //跳转告警设置
    getSetAlarm() {
      this.$router.push({
        name: "AlarmSet",
      })
      this.myaudio.pause()
      this.$store.state.MenuStore.menu_path = "运维监控 > 告警设置"
    },
    //窗体关闭
    showChange() {
      this.myaudio.pause()
      this.displayChange = false
    },
    //获取告警设置内容
    async getAlarmSet() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/warn/remind/set")
      if (res.code == 1) {
        _this.alarmRules = res.data
        //信息框是否显示
        if (_this.alarmRules.newsDisplay == 1) {
          _this.getAlarmCount()
          _this.displayChange = true
          //刷新间隔时间
          _this.setFun(_this.alarmRules)
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //告警设置函数
    setFun(data) {
      let _this = this
      //窗体关闭
      _this.closeTime = setInterval(function() {
        _this.displayChange = false
        clearInterval(_this.closeTime)
      }, data.stopTime * 60000)
      //告警数据刷新
      if (data.stopTime == data.flushTime) {
        _this.refreshTime = setInterval(function() {
          _this.displayChange = true
          _this.getAlarmCount()
        }, data.flushTime * 60000)
      } else {
        _this.refreshTime = setInterval(function() {
          _this.displayChange = true
          //窗体关闭
          _this.closeTime = setInterval(function() {
            _this.displayChange = false
            clearInterval(_this.closeTime)
          }, data.stopTime * 60000)
          _this.getAlarmCount()
        }, data.flushTime * 60000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.window {
  width: 300px;
  height: 244px;
  padding: 0 10px;
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: #c3e6ff;
  border: 1px solid #acc4d6;
  border-radius: 3px;
  z-index: 9101;
  box-sizing: border-box;
  .window-title {
    width: 100%;
    height: 34px;
    line-height: 34px;
    .title-name {
      float: left;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #054f84;
    }
    .btn-box {
      display: inline-block;
      float: right;
      height: 34px;
      span {
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .window-con {
    width: 100%;
    height: 200px;
    padding: 12px 0;
    background-color: #ddf0fe;
    box-sizing: border-box;
  }
}
.alarm-record {
  line-height: 34px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  span:first-child {
    display: inline-block;
    width: 178px;
    text-align: right;
  }
}
.red {
  color: #f6392a;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  cursor: pointer;
}
.change {
  color: #f35626;
  font-family: Microsoft YaHei;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  background-image: -webkit-linear-gradient(92deg, #f35626, #feab3a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-animation: hue 0.5s infinite linear;
}
@-webkit-keyframes hue {
  from {
    -webkit-filter: hue-rotate(0deg);
    -moz-filter: hue-rotate(0deg);
  }
  to {
    -webkit-filter: hue-rotate(-360deg);
    -moz-filter: hue-rotate(-360deg);
  }
}
</style>
